import { useState } from "react";

const faqs = [
  {
    q: "What can a solar generator power?",
    a: "It depends on the watt-hour capacity. For many systems, this includes refrigerators, lights, charging stations, fans, TVs, small appliances, and even some medical devices. Our product pages list exactly what each unit can support based on load and duration.",
  },
  {
    q: "Are solar generators better than gas generators?",
    a: "For most homeowners, yes. Solar generators are quieter, safer indoors, require zero fuel, and demand far less maintenance. They&apos;re also more practical for urban or suburban settings. Gas generators are louder, produce fumes, and require a constant fuel supply. The trade-off is capacity — large whole-home loads may still benefit from a standby gas or propane system.",
  },
  {
    q: "Do I need professional installation?",
    a: "For most portable and expandable home backup systems, no. They&apos;re specifically designed for DIY setup without any electrical work required. For whole-home standby generators, professional installation is recommended and often required by local codes.",
  },
  {
    q: "How long does a backup system last during an outage?",
    a: "Runtime varies based on system capacity and how many devices you&apos;re running. A mid-range 2kWh system can typically power basic essentials for 8–24 hours. Expandable systems with additional battery packs can run for several days, especially when paired with solar panels for daytime recharging.",
  },
  {
    q: "What is your return and warranty policy?",
    a: "We offer straightforward 30-day returns on most products and honor manufacturer warranties on all systems. Contact our support team and we&apos;ll walk you through the process — no headaches, no runaround.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-500 mt-3 text-base">
            The things people usually ask before buying backup power.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg overflow-hidden transition-all"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-semibold text-gray-900 text-sm pr-4">{faq.q}</span>
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className={`text-gray-500 text-base transition-transform duration-200 ${open === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {open === i && (
                <div className="px-5 pb-5">
                  <p
                    className="text-gray-600 text-sm leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: faq.a }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
